import React, { useState, useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './ComingSoon.module.css';

export default function ComingSoon() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [coffeeCount, setCoffeeCount] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    const handleScroll = () => setScrolled(window.scrollY > 50);
    
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const typingInterval = setInterval(() => {
      setIsTyping(prev => !prev);
    }, 1000);
    return () => clearInterval(typingInterval);
  }, []);

  const handleCoffeeClick = () => {
    setCoffeeCount(prev => prev + 1);
  };

  const messages = [
    "Coding like a caffeinated squirrel...",
    "Teaching pixels to dance...",
    "Bribing the bugs to leave...",
    "Almost there... I think... maybe...",
    "Just one more feature... or ten..."
  ];

  const [currentMessage, setCurrentMessage] = useState(0);
  const [progress, setProgress] = useState(() => Math.floor(Math.random() * 85) + 10);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setCurrentMessage(prev => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(messageInterval);
  }, []);

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      
      <div className={styles.container}>
        {/* Animated Background */}
        <div className={styles.background}>
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className={styles.particle}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 10}s`,
                animationDuration: `${20 + Math.random() * 20}s`
              }}
            />
          ))}
          {[...Array(30)].map((_, i) => (
            <div
              key={`orb-${i}`}
              className={styles.floatingOrb}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 15}s`,
                animationDuration: `${25 + Math.random() * 15}s`
              }}
            />
          ))}
        </div>

        {/* Mouse Follower */}
        <div
          className={styles.mouseFollower}
          style={{
            left: `${mousePosition.x}px`,
            top: `${mousePosition.y}px`
          }}
        />

        {/* Main Content */}
        <div className={styles.content}>
          {/* Title */}
          <h1 className={styles.title}>
            <span className={styles.titleWord}>Coming</span>
            <span className={styles.titleWord}>Soon</span>
            <span className={styles.titleWord}>ish</span>
          </h1>

          {/* Typing Message */}
          <div className={styles.messageContainer}>
            <p className={styles.message}>
              {messages[currentMessage]}
              <span className={`${styles.cursor} ${isTyping ? styles.blink : ''}`}>|</span>
            </p>
          </div>

          {/* Progress Bar */}
          <div className={styles.progressContainer}>
            <div className={styles.progressLabel}>
              <span>Progress</span>
              <span className={styles.percentage}>{progress}%</span>
            </div>
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{ width: `${progress}%` }}
              >
                <div className={styles.progressShine}></div>
              </div>
            </div>
          </div>

          {/* Interactive Coffee Button */}
          <button className={styles.coffeeButton} onClick={handleCoffeeClick}>
            <span className={styles.coffeeIcon}>☕</span>
            <span className={styles.coffeeText}>
              Fuel the Developer ({coffeeCount} cups)
            </span>
          </button>

          

          {/* Footer */}
          <p className={styles.footer}>
            <span className={styles.footerEmoji}>🚀</span>
            Meanwhile, feel free to grab a coffee and imagine how awesome this will be!
            <span className={styles.footerEmoji}>✨</span>
          </p>
        </div>
      </div>
      
      
    </>
  );
}